import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CircularProgress, Paper, makeStyles, Box, } from '@material-ui/core';
import clsx from 'clsx';
import { useModePanelStyle, } from '../../..';
import { CompPanelHeader, } from '../compPanelHeader';
const useStyle = makeStyles((theme) => {
    return {
        root: {
            overflow: 'hidden',
            height: 500,
        },
        panelContent: {
            padding: 0,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        currentValueDisplay: {
            paddingLeft: theme.spacing(1),
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
            '& .label': {
                color: theme.palette.text.secondary,
                fontSize: 15,
                marginRight: theme.spacing(1),
            },
            '& .unit': {
                color: theme.palette.text.secondary,
                marginLeft: theme.spacing(0.5),
                fontSize: 20,
            },
            '& .value': {
                fontWeight: 500,
                paddingTop: 2,
                fontSize: 30,
                color: theme.palette.text.primary,
            },
        },
        [theme.breakpoints.up('md')]: {
            currentValueDisplay: {
                '& .label': {
                    fontSize: 20,
                },
                '& .unit': {
                    fontSize: 25,
                },
                '& .value': {
                    fontSize: 35,
                },
            },
        },
        [theme.breakpoints.up('lg')]: {
            currentValueDisplay: {
                '& .label': {
                    fontSize: 25,
                },
                '& .unit': {
                    fontSize: 35,
                },
                '& .value': {
                    fontSize: 45,
                },
            },
        },
    };
}, {
    name: 'TimeSeriesChartPanel', index: 1,
});
/**
 * This component is just a panel to wrap charts. It has logic to show/hide charts based on the data count and some logic for the
 * header but otherwise it doesn't do anything else.
 */
export const TimeSeriesChartPanelWithCurrentValue = (props) => {
    const panelClasses = useModePanelStyle();
    const classes = useStyle();
    return (_jsxs(Paper, { elevation: 2, className: clsx(panelClasses.root, classes.root, props.className, props.showCustomActionOnHover && 'show-custom-action-on-hover'), children: [_jsx(CompPanelHeader, { ...props, customContent: (_jsx(_Fragment, { children: props.currentValue && (_jsxs("div", { className: clsx(classes.currentValueDisplay, props.currentValue.className), children: [props.currentValue.label && (_jsx("div", { className: "label", children: props.currentValue.label })), _jsx("div", { className: "value", children: props.currentValue.value }), props.currentValue.unit && (_jsx("div", { className: "unit", children: props.currentValue.unit }))] })) })) }), _jsxs("div", { className: clsx(panelClasses.panelContent, classes.panelContent), children: [props.seriesCount !== undefined && props.seriesCount > 0 && props.dataCount !== undefined && props.dataCount > 0 && (props.children), (props.seriesCount === 0 || props.dataCount === 0) && props.noDataMessageComp, props.dataCount === undefined && (_jsx(Box, { padding: 2, children: _jsx(CircularProgress, {}) }))] })] }));
};
